import { Language } from 'types/language'
import { TestimonialsType } from './types'

export const Testimonials: TestimonialsType = {
  [Language.DUTCH]: [
    {
      image: 'bart_marijke.jpg',
      text: 'Het is fijn om mensen rechtstreeks onze energie aan te kunnen bieden. Niet enkel onze patatjes, maar ook de elektriciteit: recht van de boer.',
      name: 'Energie-opwekkers Bart en Marijke'
    },
    {
      image: 'eva_de_roo.png',
      text: 'Als je niet weet wie jouw stroom opwekt, kan je nooit zeker zijn dat je groen kiest.',
      name: 'Eva De Roo, energie-afnemer bij Bolt'
    },
    {
      image: 'laura.jpg',
      text: 'Over and out met groengewassen stroom uit het buitenland. Na groenten en kledij koop ik vanaf nu ook mijn stroom lokaal.',
      name: 'Laura Van de Woestijne, energie-afnemer bij Bolt'
    }
  ],
  [Language.FRENCH]: [
    {
      image: 'olivier.png',
      text: 'Nous sommes heureux que Bolt fasse le lien entre nos éoliennes et les habitants de la région.',
      name: 'Olivier, producteur de l’énergie'
    },
    {
      image: 'birgit.png',
      text: "C'est agréable d'être le client d'un fournisseur honnête et transparent, qui veut faire du bien à la planète ! Bolt est très serviable et l'échange s'est déroulé sans problème. Nous sommes des fans !",
      name: 'Birgit, consommateur d’énergie'
    },
    {
      image: 'charlotte.png',
      text: "Je suis vraiment conquise par ce super concept, un grand oui pour de l'énergie éthique et verte!!!",
      name: 'Charlotte, consommateur d’énergie'
    }
  ]
}
